import React, { useContext, useCallback } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import AdjustSliderControl from 'components/tools/adjust/AdjustSliderControl';

export default function HueRotationControl() {
  const { hueRotate, setHueRotate } = useContext(CanvasContext);

  const handleStoredChange = useCallback(
    (next) => setHueRotate(next),
    [setHueRotate]
  );

  return (
    <AdjustSliderControl
      id="hue-rotate"
      label="Hue"
      value={hueRotate}
      onChange={handleStoredChange}
      min={-180}
      max={180}
      step={1}
      defaultValue={0}
      formatValue={(_stored, slider) => `${slider}°`}
    />
  );
}
